module.exports = __webpack_public_path__ + "8c6f97276ceb86b41e46ce1f2a538319.pdf";